export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                随时随地，畅享漫画
              </h2>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                汗汗漫画全面适配手机端和平板端，无论在哪里都能流畅阅读。在线看漫画海量免费内容随时追更，一次看过瘾！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  Android 版
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-3 border border-background-300/40 hover:border-primary-400/60 text-background-200 hover:text-primary-300 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 版
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-3 border border-background-300/40 hover:border-primary-400/60 text-background-200 hover:text-primary-300 font-semibold rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-computer-line text-lg"></i>
                  网页版
                </span>
              </div>
            </div>
            <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20reading%20app%20interface%20with%20colorful%20comic%20pages%2C%20warm%20orange%20and%20coral%20UI%20design%2C%20clean%20modern%20layout%2C%20floating%20phone%20on%20transparent%20background%2C%20high%20quality%20product%20mockup&width=500&height=700&seq=app-showcase-manga-2026&orientation=portrait"
                alt="汗汗漫画移动端展示"
                className="max-h-[400px] w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}